<template>
    <a-drawer
        :title="'指导论文-'+actionName"
        placement="right"
        :closable="false"
        :visible="visible"
        @close="onClose"
        width="30%">
        <div class="input-box">
            <p>系别：</p>
            <a-select
                class="input"
                show-search
                :filter-option="filterOption"
                @search="handSearch"
                v-model="info.departmentCode"
                allowClear
                :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in xbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>教师名：</p>
            <a-select 
                class="input" 
                allowClear
                show-search
                :filter-option="false"
                @search="teacherSearch"
                v-model="info.teacherNo"
                @change="teacherChange"
                option-label-prop="label"
                :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in jsArr" :key="index" :value="item.teacherId" :label="item.teacherName">{{item.teacherId}}-{{item.teacherName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>类别：</p>
            <a-select
                class="input"
                show-search
                :filter-option="filterOption"
                v-model="info.paperTypeCode"
                allowClear
                :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in lbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>人数：</p>
            <a-input-number class="input" :disabled="actionName=='查看'" v-model="info.personNumber" />
        </div>
        <div class="input-box">
            <p>核定分值：</p>
            <a-input-number class="input" :disabled="actionName=='查看'" v-model="info.approvedScore" />
        </div>
        <div class="input-box">
            <p>学年：</p>
            <a-select
                class="input"
                show-search
                :filter-option="filterOption"
                v-model="info.schoolYearCode"
                allowClear
                :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in xnArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>备注：</p>
            <a-textarea class="input" :rows="4" :disabled="actionName=='查看'" v-model="info.remark" />
        </div>
        <div class="btn-box">
            <a-button type="primary" @click="sub" v-if="actionName!='查看'">提交</a-button>
            <a-button @click="onClose">取消</a-button>
        </div>
    </a-drawer>

</template>

<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { add,update,info } from '@/baseAPI/undergraduate/culture/guidancePaper'
    import { getTeacher } from '@/baseAPI/facultyTeacher'
    export default {
        name: '',
        components: {
        },
        computed: {},
        data() {
            return {
                actionName:'',
                visible:false,
                id:'',
                info:{
                    departmentCode:null,
                    teacherNo:null,
                    teacherName:null,
                    paperTypeCode:null,
                    personNumber:null,
                    approvedScore:null,
                    schoolYearCode:null,
                    remark:null,
                },
                jsArr:[],
                xbArr:[],
                lbArr:[],
                xnArr:[],
            }
        },
        mounted () {
        },
        methods:{
            getInfo(){
                getDicts({dataCode:'XY',status:true}).then(res=>{
                    this.xbArr=res.data.dicts;
                    this.info.departmentCode=res.data.defaultValue[0]
                })
                getDicts({dataCode:'LWLB',status:true}).then(res=>{
                    this.lbArr=res.data.dicts;
                    this.info.paperTypeCode=res.data.defaultValue[0]
                })
                getDicts({dataCode:'XN',status:true}).then(res=>{
                    this.xnArr=res.data.dicts;
                    this.info.schoolYearCode=res.data.defaultValue[0]
                })
                if(this.actionName!='新增'){
                    info(this.id).then(res=>{
                        this.info=res.data;
                        this.teacherSearch(this.info.teacherNo)
                    })
                }
            },
            showDrawer(name,id){
                this.id=id;
                this.actionName=name;
                this.getInfo();
                this.visible=true;
            },
            onClose() {
                this.info={
                    departmentCode:null,
                    teacherNo:null,
                    teacherName:null,
                    paperTypeCode:null,
                    personNumber:null,
                    approvedScore:null,
                    schoolYearCode:null,
                    remark:null,
                };
                this.visible = false;
                this.$parent.fetch()
            },
            handSearch(value){
                if(value!=''){
                    this.info.departmentCode=value
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            teacherSearch(value){
                getTeacher({teacherName:value}).then(res=>{
                    this.jsArr=res.data;
                })
            },
            teacherChange(value){
                for(let i=0;i<this.jsArr.length;i++){
                    if(this.jsArr[i].teacherId==value){
                        this.info.teacherName=this.jsArr[i].teacherName
                    }
                }
            },
            sub(){
                var isSub=true;
                var arr=['remark','approvalStatus']
                for(let key in this.info){
                    if(arr.indexOf(key)<0){
                        if(this.info[key]==null||this.info[key]===''){
                            isSub=false;
                            break;
                        }
                    }
                }
                if(isSub){
                    if(this.actionName=='新增'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增指导论文成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改指导论文成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            },

        }
    }
</script>

<style scoped>
    .ant-drawer >>> .ant-drawer-header{
        background-color: #245086;
        border-radius: 0;
    }
    .ant-drawer >>> .ant-drawer-title{
        color: #fff;
        font-weight: bold;
        letter-spacing: 1px;
        font-size: 1.1rem;
    }
    .input-box{
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .input-box p{
        width: 8rem;
        text-align: right;
    }
    .input-box .input{
        width: calc(100% - 8rem);
    }
    .input-box .tips{
        width: calc(100% - 8rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .btn-box{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: right;
        padding-bottom: 1rem;
        background-color: #fff;
    }
    .btn-box .ant-btn{
        margin-right: 2rem;
    }
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }

</style>
